import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase/app";

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import "firebase/analytics";

// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/firestore";

import {
    BrowserRouter as Router,
    Switch,
    Route    
  } from "react-router-dom";
import ArtistPage from './ArtistPage/ArtistPage';
import ArtistDashboard from './ArtistArea/ArtistDashboard';

const firebaseConfig = {
  apiKey: "AIzaSyBkNIG1Ek45XcnwA0bj4x1CirveQtOD4dQ",
  authDomain: "prospectorrecords-76f40.firebaseapp.com",
//   authDomain: "auth.prospector-records.uk ",
  databaseURL: "https://prospectorrecords-76f40.firebaseio.com",
  projectId: "prospectorrecords-76f40",
  storageBucket: "prospectorrecords-76f40.appspot.com",
  messagingSenderId: "1034512554307",
  appId: "1:1034512554307:web:e860bc6ffb78f4a548f7f6"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

ReactDOM.render(
    <React.StrictMode>
        <Router>
            <Switch>
                <Route path="/artist/:id" component={ArtistPage} />
                <Route path="/dashboard" component={ArtistDashboard} />
                <Route path="/" component={App} />
            </Switch>
        </Router>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
